module.exports = __webpack_public_path__ + "static/media/bet-orange-3.2c9087aa.png";